import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { AlertService, NavigationService, ResourceService } from 'sce-core';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
@Component({
  selector: 'lfwms-computed-uom-popup',
  templateUrl: './computed-uom-popup.component.html',
  styleUrls: ['./computed-uom-popup.component.css']
})
export class ComputedUOMPopupComponent {

  public fromRowCells: any;
  public toRowCells: any;
  public http$ = this.coreServiceRegistry.http$;
  public response: any;
  public fromUomKey: any;
  public fromUomValue: any;
  public toUomKey: any;
  public toUomValue: any;
  public fromUnitQty :any = 0;
  public toUnitQty: any = 0;
  public isLoading: boolean = true;
  public selectedRow: any;
  public toMasteruom: any;
  public fromMasteruom: any;
  public tableId: any;
  public eventSubject = new Subject<any>();

  constructor(public modalService: ModalService,
    private resourceService: ResourceService,
    protected sharedServiceRegistry: SharedServiceRegistry,
    protected coreServiceRegistry: CoreServiceRegistry, protected alertService: AlertService,
    protected navService: NavigationService) {
  }



  public ngOnInit() {
    this.computeUom().subscribe((resp: any) => {
      if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
        if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
          let fromUom = resp['fromUomValues'].split(":");
          this.fromUomKey = fromUom[0];
          this.fromUomValue = fromUom[1];
          let toUom = resp['toUomValues'].split(":");
          this.toUomKey = toUom[0];
          this.toUomValue = toUom[1];
          this.fromUnitQty = resp['fromUnitQty'];
          this.toUnitQty = resp['toUnitQty']
          this.fromMasteruom = resp['fromMasterUom'];
          this.toMasteruom = resp['toMasterUom'];
        } else {
          this.alertService.clearAll();
          this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
        }
      } else {
        if (resp.error) {
          this.alertService.clearAll();
          this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
        }
      }
    }, (error) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  //LFWM - 3038 functionc alled when value of any field changes
  public valueChanged(type: any, property: any, sourceEvent: any) {
    let newVal = null;
    let hasValueChanged: boolean;

    let row: any;
    if (type === 'from') {
      row = this.fromRowCells;
    } else if (type === 'to') {
      row = this.toRowCells;
    }
    if (sourceEvent !== null && sourceEvent !== undefined) {
      if ('string' === typeof sourceEvent) {
        newVal = sourceEvent;
      } else if ('object' === typeof sourceEvent) {
        newVal = sourceEvent['newVal'];
      }
    }

    if (newVal === null || newVal === undefined) {
      newVal = row.cells[property].cVal;
    }
    row.cells[property].isEdited = (row.cells[property].cVal !== row.cells[property].cValOrig);

    if (sourceEvent && sourceEvent.type && sourceEvent.type === 'dropdown') {
      hasValueChanged = (newVal !== sourceEvent.prevVal);
    } else {
      hasValueChanged = (newVal !== row.cells[property].cVal);
    }

    if (row.cells[property].isEdited || hasValueChanged) {

      row.isEdited = true;

      if (sourceEvent && sourceEvent.type && sourceEvent.type === 'dropdown') {
        // Code changes to fix checkbox selection issue LFWM-1718
        row.cells[property].cValPrev = sourceEvent.prevVal;
        row.cells[property].cVal = newVal;
        row.cells[property].cValOldUOM = row.cells[property].cValPrev;
        this.autoPopulateValues(row, property);
      } else {
        row.cells[property].cValPrev = row.cells[property].cVal;
        row.cells[property].cVal = newVal;
      }
    }
  }

  public autoPopulateValues(row: any, colName: any) {
    if (colName === 'TRANS_UOM') {
      if (row.cells[colName].cVal === '') {
        row.cells[colName].isValueInvalid = true;
        row.focusedCellId = colName;
        return;
      } else if (row.cells[colName].cValOldUOM === '') {
        // if packkey is reset do not call ComputeUOM
        row.cells[colName].isValueInvalid = false;

        return;
      }
      row.cells[colName].isValueInvalid = false;

      const oldUomVal = row.cells[colName].cValOldUOM;
      const newUomVal = row.cells[colName].cVal;
      const packKeyVal = row.cells['pack'].cVal;
      const fromQty = row.cells['qty'].cVal;
      if (fromQty === 0) {
        row.cells['qty'].isValueInvalid = false;
        row.cells['qty'].isLoading = false;
        row.focusedCellId = 'qty';
        return; // return if both values are zero. i.e no service call reqd
      }
      // LFWM-3191-adding tableId in the request object
      const reqObj = {
        fromExpectedQty: fromQty ? fromQty : 0,
        fromReceivedQty: '',
        fromUOM: oldUomVal,
        toUOM: newUomVal,
        packKey: packKeyVal,
        tableId: this.tableId
      };
      this.autoPopulateUOMFeilds(reqObj)
        .subscribe((res: any) => {
          if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
            row.cells['qty'].cValPrev = row.cells['qty'].cVal;
            row.cells['qty'].cVal = res.toExpectedQty;
            row.cells['qty'].isEdited = true;
            row.cells['qty'].isValueInvalid = false;
            row.cells['qty'].isLoading = false;
            row.focusedCellId = 'qty';
          } else {
            this.alertService.clearAll().error('Could not fetch from qty on UOM change');
            row.cells['qty'].isValueInvalid = true;
            row.cells['qty'].isLoading = false;
            row.focusedCellId = 'TRANS_UOM';
          }
        }, (error) => {
          this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
        });
    }
  }

  public qtyChanged(type: any, property: any, sourceEvent: any) {
    let newVal = null;
    let hasValueChanged: boolean;

    let row: any;
    if (type === 'from') {
      row = this.fromRowCells;
    } else if (type === 'to') {
      row = this.toRowCells;
    }

    newVal = sourceEvent.target.value;
    if (property === 'qty') {
      if (newVal === null || newVal === undefined) {
        newVal = row.cells[property].cVal;
      }
      row.cells[property].isEdited = (row.cells[property].cVal !== row.cells[property].cValOrig);

      hasValueChanged = (newVal !== row.cells[property].cVal);

      if (row.cells[property].isEdited || hasValueChanged) {
        row.isEdited = true;
        row.cells[property].cValPrev = row.cells[property].cVal;
        row.cells[property].cVal = newVal;
        this.changeUnitQty(row, type);
      }
    } else if (property === 'unitQty') {
      if (type === 'from') {
        this.fromUnitQty = newVal;
      } else if (type === 'to') {
        this.toUnitQty = newVal;
      }
      this.changeQty(row, type, newVal);
    }
  }

  //LFWM-3038 function to change unitQty and computeUom based on the value of qty
  public changeUnitQty(row: any, type: any) {
    const oldUomVal = row.cells['TRANS_UOM'].cVal;
    let newUomVal;
    if (type == 'from') {
      newUomVal = this.fromMasteruom;
    } else if (type == 'to') {
      newUomVal = this.toMasteruom;
    }
    const packKeyVal = row.cells['pack'].cVal;
    let fromQty = row.cells['qty'].cVal;
    if (fromQty === 0) {
      row.cells['qty'].isValueInvalid = false;
      row.cells['qty'].isLoading = false;
      row.focusedCellId = 'qty';
      return; // return if both values are zero. i.e no service call reqd
    }
    const errorMsgForQty = this.sharedServiceRegistry.validatorService.validateField(fromQty,
      'Integer', this.alertService, 'qc_toqty');
    if (errorMsgForQty.length > 0) {
      row.cells['qty'].cVal = 0;
      this.alertService.clearAll().error(this.resourceService.get(errorMsgForQty) + ' - '
        + this.resourceService.get('qc_toqty'));
      return;
    }
    const reqObj = {
      fromExpectedQty: fromQty || 0,
      fromReceivedQty: '',
      fromUOM: oldUomVal,
      toUOM: newUomVal,
      packKey: packKeyVal,
      tableId: this.tableId
    };
    this.autoPopulateUOMFeilds(reqObj)
      .subscribe((res: any) => {
        if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
          if (type == 'from') {
            this.fromUnitQty = res.toExpectedQty;
          } else if (type == 'to') {
            this.toUnitQty = res.toExpectedQty;
          }
          this.computeUom().subscribe((resp: any) => {

            if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
              let fromUom = resp['fromUomValues'].split(":");
              this.fromUomKey = fromUom[0];
              this.fromUomValue = fromUom[1];
              let toUom = resp['toUomValues'].split(":");
              this.toUomKey = toUom[0];
              this.toUomValue = toUom[1];
              this.fromUnitQty = resp['fromUnitQty'];
              this.toUnitQty = resp['toUnitQty']
            } else {
              this.alertService.clearAll();
              this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
          });

        } else {
          this.alertService.clearAll().error('Could not fetch from qty on UOM change');
          row.cells['qty'].isValueInvalid = true;
          row.cells['qty'].isLoading = false;
          row.focusedCellId = 'TRANS_UOM';
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });


  }

//LFWM-3038 function to change qty and computeUom based on the unitQty value
  public changeQty(row: any, type: any, newVal: any) {
    let oldUomVal;
    if(type==='to'){
      oldUomVal = this.toMasteruom;
    }else if(type==='from'){
      oldUomVal = this.fromMasteruom;
    }
    const newUomVal = row.cells['TRANS_UOM'].cVal;
    const packKeyVal = row.cells['pack'].cVal;
    const fromQty = newVal;

    if (fromQty === 0) {
      row.cells['qty'].isValueInvalid = false;
      row.cells['qty'].isLoading = false;
      row.focusedCellId = 'qty';
      return; // return if both values are zero. i.e no service call reqd
    }
    const errorMsgForQty = this.sharedServiceRegistry.validatorService.validateField(fromQty,
      'Integer', this.alertService, 'qc_toqty');
    if (errorMsgForQty.length > 0) {
      this.alertService.clearAll().error(this.resourceService.get(errorMsgForQty) + ' - '
        + this.resourceService.get('qc_toqty'));
      return;
    }
    const reqObj = {
      fromExpectedQty: fromQty || 0,
      fromReceivedQty: '',
      fromUOM: oldUomVal,
      toUOM: newUomVal,
      packKey: packKeyVal,
      tableId: this.tableId
    };
    this.autoPopulateUOMFeilds(reqObj)
      .subscribe((res: any) => {
        if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
          row.cells['qty'].cValPrev = row.cells['qty'].cVal;
          row.cells['qty'].cVal = res.toExpectedQty;
          row.cells['qty'].isEdited = true;
          row.cells['qty'].isValueInvalid = false;
          row.cells['qty'].isLoading = false;
          row.focusedCellId = 'qty';
        } else {
          this.alertService.clearAll().error('Could not fetch from qty on UOM change');
          row.cells['qty'].isValueInvalid = true;
          row.cells['qty'].isLoading = false;
          row.focusedCellId = 'TRANS_UOM';
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });

    this.computeUom().subscribe((resp: any) => {

      if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
        let fromUom = resp['fromUomValues'].split(":");
        this.fromUomKey = fromUom[0];
        this.fromUomValue = fromUom[1];
        let toUom = resp['toUomValues'].split(":");
        this.toUomKey = toUom[0];
        this.toUomValue = toUom[1];
        this.fromUnitQty = resp['fromUnitQty'];
        this.toUnitQty = resp['toUnitQty']
        this.alertService.clearAll();
      } else {
        this.alertService.clearAll();
        this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
      }
    }, (error) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }
  //LFWM-3038 Function call to get computeUom
  public computeUom() {
    const request = {
      'fromPack': this.fromRowCells.cells['pack'].cVal,
      'toPack': this.toRowCells.cells['pack'].cVal,
      'channelTransKey': this.selectedRow.cells['channel_transfer_id'].cVal,
      'lineNo' : this.selectedRow.cells['lineNo'].cVal,
      'fromUnitQty': this.fromUnitQty ? this.fromUnitQty : "",
      'toUnitQty': this.toUnitQty ? this.toUnitQty : ""
    };
    const response$ = this.http$.post('api/inventory/channeltransfer/computedUom', JSON.stringify(request))
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  //LFWM-3038 function call to get value of qty based on UOM value
  public autoPopulateUOMFeilds(reqObj: any) {
    const response$ = this.http$.put('api/asn/UOM/compute/', JSON.stringify(reqObj))
      .catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
      });
    return response$;
  }

  public saveValues() {
    this.notifyEvent({'fromRow': this.fromRowCells, 'toRow':this.toRowCells });
  }

  public notifyEvent(event : any) {
    this.eventSubject.next(event);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();

  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/computed-uom-popup/computed-uom-popup.component.ts